import PropTypes from 'prop-types';
import {createUseStyles, useTheme} from 'react-jss';
import {connect} from 'react-redux';
import BasketItemImageV2 from './BasketItemImageV2';
import {isMobile} from '../../../selectors/DeviceSelectors';

const useStyles = createUseStyles({
  basketItemImageWrapper: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'left',
    minHeight: 70,
    margin: 'auto',
    backgroundColor: props => (props.theme.basketItemWrapperBackgroundColour
      ? props.theme.basketItemWrapperBackgroundColour : '#fff'),
    paddingBottom: 12,
  },
  productWrapper: props => (props.isDeliverySection ? ({
    width: '100%',
    maxWidth: (props.mobile ? '100%' : '50%'),
    display: 'flex',
    height: '100%',
    alignItems: 'center',
  }) : ({})),
  productTitle: {
    marginLeft: 5,
  },
});

export function BasketItemImageWrapperV2(props) {
  const theme = useTheme();
  const classes = useStyles({theme, ...props});
  
  const getBasketItemImage = (item, index) => {
    if (props.mergedGroupsEnabled) {
      return (
        <div className={classes.productWrapper}>
          <BasketItemImageV2
            key={item.productImage}
            productUrl={item.productImage}
            quantity={item.quantity}
            additionalItems={props.additionalItems}
            isLastDisplayableItem={index === props.displayableBasketItems.length - 1}
            title={item.title}
            mergedGroupsEnabled={props.mergedGroupsEnabled}
          />
          {props.mergedGroupsEnabled && <p className={classes.productTitle}>{item.title}</p>}
        </div>
      );
    }
    
    return (
      <BasketItemImageV2
        key={item.productImage}
        productUrl={item.productImage}
        quantity={item.quantity}
        additionalItems={props.additionalItems}
        isLastDisplayableItem={index === props.displayableBasketItems.length - 1}
        title={item.title}
        mergedGroupsEnabled={props.mergedGroupsEnabled}
      />
    );
  };
  
  return (
    <span className={classes.basketItemImageWrapper} data-test="BasketItemImageWrapperV2">
      {props.displayableBasketItems.map((item, index) => getBasketItemImage(item, index))}
    </span>
  );
}

BasketItemImageWrapperV2.propTypes = {
  displayableBasketItems: PropTypes.arrayOf(PropTypes.shape({
    productUrl: PropTypes.string,
    productName: PropTypes.string,
    quantity: PropTypes.number,
    totalPrice: PropTypes.string,
    discountedPrice: PropTypes.string,
  })).isRequired,
  additionalItems: PropTypes.number.isRequired,
  mergedGroupsEnabled: PropTypes.bool,
};

const mapStateToProps = (state, ownProps) => {
  const imagesThatWillFit = Math.floor(state.ui.screenDimensions.width / 86);
  const maxItems = Math.min(imagesThatWillFit, 8);
  const mobile = isMobile(state);
  
  const displayableBasketItems = (ownProps.mergedGroupsEnabled && ownProps.isDeliverySection)
    ? ownProps.basketItems.slice(0, mobile ? 1 : 2)
    : ownProps.basketItems.slice(0, Math.max(maxItems, 1));
  return {
    displayableBasketItems,
    mobile,
    additionalItems: ownProps.basketItems.length - displayableBasketItems.length,
  };
};

export default connect(mapStateToProps)(BasketItemImageWrapperV2);
